var map = {
	"./backArrow.svg": "6d03",
	"./blackFridayBox.svg": "92e4",
	"./browserProfilesIcon.svg": "c4c3",
	"./close.svg": "7d45",
	"./commentQuestion.svg": "e245",
	"./cryingFace.svg": "38c5",
	"./dMarkLogo.svg": "5269",
	"./emojis/check.png": "1868",
	"./emojis/checkIcon.png": "ac13",
	"./emojis/close.png": "b122",
	"./emojis/cool.png": "4e19",
	"./emojis/crown.png": "87bc",
	"./emojis/eyes.png": "fede",
	"./emojis/foldedHands.png": "b3c8",
	"./emojis/handshake.png": "5462",
	"./emojis/iLoveYouSign.png": "b9d7",
	"./emojis/muscle.png": "d0cb",
	"./emojis/peaceSign.png": "ab89",
	"./emojis/raisedHands.png": "eb2c",
	"./emojis/smiling.png": "2ba5",
	"./emojis/thinkingFace.png": "29d6",
	"./heartsQuestion.svg": "eaa6",
	"./instagramIcon.svg": "be49",
	"./logo.svg": "4e17",
	"./messengerIcon.svg": "d00b",
	"./telegramIcon.svg": "e256",
	"./telegramQuestion.svg": "b834",
	"./thank-you.png": "c8f6",
	"./usersQuestion.svg": "510e",
	"./viberIcon.svg": "40f7",
	"./weChatIcon.svg": "27c1",
	"./whatsAppIcon.svg": "9e0a",
	"./xIcon.svg": "3d13"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51b88";